import { Container } from '@mui/material';
import styled from 'styled-components';

import { RadioButtonRow } from 'components/RadioButtonRow';
import { colors, layout } from 'config/theme';

export const H1 = styled.h1`
  font-size: 1.5rem;
  color: ${colors.black};
`;

export const InfoCellColumn = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 300px;
`;

export const InfoCellRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const HR = styled.hr`
  border-top: 1px solid ${colors.lightGray};
  margin-top: 30px;
`;

export const StyledRadioButtonGroup = styled(RadioButtonRow)`
  label:first-child {
    font-size: 1.3rem;
    color: ${colors.darkerGray};
    font-weight: 200;
    margin-bottom: 0px;
    margin-top: 15px;
  }
  label {
    font-size: 1rem;
    margin-bottom: 15px;
  }
  input[type='radio'] {
    border: 0px;
    width: 1.5em;
    height: 1.5em;
  }
`;

export const CandidateContractWrapper = styled(Container)`
  padding: 40px 50px;
  border-radius: 5px;
  background: white;
  outline: ${layout.borderRadius.s} solid ${colors.lightGray};
  max-width: 700px;
  margin-top: 20px;
  margin-bottom: 20px;
`;
